<template>
    <div>
        <div class="pt-5 pl-5" v-if="documentos.length > 0">
            <botao-novo-documento @novoDocumento="$emit('novoDocumento')"/>
        </div>

        <Tabela
            :key="keyTabela"
            class="table-documentos"
            :colunas="headers"
            :lista="documentos"
            :paginacaoTabela="paginacaoTabela"
            :loading="loading"
            :paginacaoAtiva="false"
            :desabilitaAlturaMaxima="desabilitaAlturaMaxima"
        >
            <template v-slot:listagemVazia>
                <documentos-vazio @novoDocumento="$emit('novoDocumento')"/>
            </template>
        </Tabela>

        <modal-assinar-documento
            ref="ModalAssinarDocumento"
            @assinatura-realizada="$emit('atualizarListagem')"
        />

        <modal-convidar-signatarios
            ref="ModalConvidarSignatarios"
            @atualizarConvidados="atualizarConvidados"
        />
    </div>
</template>

<script>
    import formatarData from '@/views/filters/formatar-data'
    import Tabela from '@/views/components/tabela/Tabela.vue'
    import ModalAssinarDocumento from '@/views/components/modal/documento/assinatura/ModalAssinarDocumento.vue'
    import ModalConvidarSignatarios from '@/views/components/modal/documento/convidados/ModalConvidarSignatarios'
    import BotaoNovoDocumento from '@/views/components/documento/BotaoNovoDocumento'
    import DocumentosVazio from '@/views/components/documento/DocumentosVazio'
    import {mapActions} from 'vuex'
    import {actionTypes} from '@/core/constants'

    export default {
        name: 'ListagemDocumentos',

        components: {DocumentosVazio, ModalConvidarSignatarios, ModalAssinarDocumento, Tabela, BotaoNovoDocumento},

        emits: ['atualizarListagem', 'baixar', 'novoDocumento'],

        data() {
            return {
                keyTabela: 0,
                usuarioSessao: undefined,
                paginacaoTabela: {
                    itemsPerPage: this.documentos.length,
                    sortDesc: [true],
                    descending: [true],
                    sortBy: ['dataCadastro'],
                    defaultSortBy: ['dataCadastro'],
                },
            }
        },

        props: {
            documentos: {
                type: Array,
                required: true,
            },
            loading: {
                type: Boolean,
                default: false,
            },
            desabilitaAlturaMaxima: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        computed: {
            headers() {
                return [
                    {
                        text: 'Título',
                        value: 'titulo',
                        type: 'icone',
                        exibirOrdenacao: true,
                        formatter: (value) => value || '-',
                        icone: (_, { documentoReservado }) => documentoReservado ? 'fas fa-file-lines' : 'attach_file',
                        sizeIcone: 16,
                    },
                    {
                        text: 'Tipo',
                        value: 'tipoDescricao',
                        exibirOrdenacao: true,
                    },
                    {
                        text: 'Data Cadastro',
                        value: 'dataCadastro',
                        exibirOrdenacao: true,
                        formatter: (value) => formatarData(value)
                    },
                    {text: 'Criado por', value: 'usuarioCadastro', exibirOrdenacao: true},
                    {
                        text: 'Convidados',
                        type: 'button',
                        width: 120,
                        list: [
                            {
                                icone: 'fas fa-user',
                                type: 'menu',
                                trigger: 'hover',
                                text: ({signatarios}) => this.formatarQuantidadeSignatarios(signatarios),
                                listMenu: (item) => this.formatarListaConvidados(item)
                            }
                        ]
                    },
                    {
                        text: 'Ações',
                        type: 'button',
                        width: 80,
                        list: [
                            {
                                type: 'button-tooltip',
                                icone: 'fas fa-signature',
                                mensagemTooltip: 'Assinar documento',
                                clickBtn: (item) => this.abrirModalAssinatura(item),
                                visible: (item) => this.deveExibirBotaoAssinar(item)
                            },
                            {
                                icone: 'fas fa-ellipsis-vertical',
                                type: 'menu',
                                left: true,
                                offset_y: true,
                                offset_x: true,
                                listMenu: [
                                    {
                                        text: 'Baixar',
                                        icone: 'fas fa-download',
                                        clickBtn: (item) => this.$emit('baixar', item)
                                    },
                                    {
                                        text: 'Convidar',
                                        icone: 'fas fa-user-plus',
                                        clickBtn: (item) => this.convidarSignatarios(item),
                                        visible: (item) => this.deveExibirBotaoConvidar(item)
                                    },

                                    {
                                        text: 'Excluir',
                                        icone: 'fas fa-trash',
                                        clickBtn: (item) => this.mostrarConfirmacaoExcluir(item),
                                        visible: (item) => this.deveExibirBotaoExcluir(item)
                                    },
                                ]
                            },
                        ]
                    },
                ]
            }
        },

        created() {
            this.capturaDadosUsuario()
        },

        methods: {
            ...mapActions([
                actionTypes.COMUM.BUSCAR_DADOS_SESSAO_USUARIO,
            ]),
            async capturaDadosUsuario() {
                this.usuarioSessao = await this.buscarDadosSessaoUsuario()
            },
            isDocumentoPdf(item) {
                const uri = item.uriAnexo
                const extensao = uri ? uri.substring(uri.lastIndexOf('.')) : undefined
                return extensao === '.pdf'
            },
            comparaEmail(email1, email2) {
                email1 = email1 || ''
                email2 = email2 || ''
                return email1.toLowerCase() === email2.toLowerCase()
            },
            usuarioAssinou(item) {
                if (!this.usuarioSessao || !item.assinaturas || !item.assinaturas.length) return false

                return item.assinaturas.find(
                    (assinador) => assinador && assinador.confirmacaoDeAutenticidade
                        && (this.comparaEmail(
                            assinador.confirmacaoDeAutenticidade.email, this.usuarioSessao.email
                        ) || this.comparaEmail(
                            assinador.confirmacaoDeAutenticidade.email, this.usuarioSessao.emailContato
                        ))) !== undefined
            },
            validarAssinaturaDocumento(item) {
                if (!this.isDocumentoPdf(item)) {
                    this.mostrarNotificacaoErro('Somente PDF\'s podem ser assinados')
                    return false
                }

                if (this.usuarioAssinou(item)) {
                    this.mostrarNotificacaoErro('Usuário já assinou esse documento.')
                    return false
                }

                return true
            },
            abrirModalAssinatura(item) {
                if (!this.validarAssinaturaDocumento(item)) return

                this.$refs.ModalAssinarDocumento.abrirModal(item)
            },
            signatarioAssinou(situacao) {
                return situacao === 'ASSINADO'
            },
            formatarQuantidadeSignatarios(signatarios) {
                if (!signatarios || !signatarios.length) return '0/0'

                const quantidadeTotal = signatarios.length
                const quantidadeAssinados = signatarios.filter(({situacao}) => this.signatarioAssinou(situacao)).length

                return `${quantidadeAssinados}/${quantidadeTotal}`
            },
            formatarListaConvidados({signatarios}) {
                if (!signatarios || !signatarios.length) return [{
                    text: 'Nenhum convidado',
                    classItem: 'height-convidados',
                }]

                const convidados = signatarios
                    .filter((_, index) => index < 5)
                    .map((signatario) => ({
                        text: signatario.email,
                        icone: this.signatarioAssinou(signatario.situacao) ? 'fas fa-check' : 'fas fa-clock',
                        classItem: 'height-convidados',
                        colorIcone: this.signatarioAssinou(signatario.situacao) ? 'green' : ''
                    }))

                if (signatarios.length > 5) {
                    convidados.push({
                        text: 'Ver todos',
                        classItem: 'height-convidados',
                        classItemTitle: 'd-flex justify-center align-center titulo-convidados',
                        clickBtn: (item) => this.convidarSignatarios(item)
                    })
                }

                return convidados
            },
            deveExibirBotaoAssinar(documento) {
                return this.isDocumentoPdf(documento) && documento.idExterno && !this.usuarioAssinou(documento)
            },
            deveExibirBotaoConvidar(documento) {
                return this.isDocumentoPdf(documento) && documento.idExterno
            },
            deveExibirBotaoExcluir(documento) {
                return !documento.documentoReservado && Boolean(documento.id)
            },
            convidarSignatarios(documento) {
                this.$refs.ModalConvidarSignatarios.abrirModal(documento)
            },
            async mostrarConfirmacaoExcluir(documento) {
                this.mostrarConfirmacao({
                    titulo: 'Atenção!',
                    html: `Atenção! O anexo a seguir será excluído:
                        <br><strong>${documento.titulo ? documento.titulo : documento.numero}</strong>
                        <br><br>Você tem certeza?`,
                    textoBotaoConfirm: 'Confirmar',
                    textoBotaoCancel: 'Cancelar',
                    icon: 'warning',
                    width: '60em'
                }, async (result) => {
                    if (result.isConfirmed) {
                        await this.$emit('excluir', documento)
                    }
                })
            },
            atualizarConvidados() {
                this.$emit('atualizarListagem')
            },
        }
    }
</script>


<style lang="stylus">
.table-documentos .v-data-table-header tr th span, .titulo-convidados
    color: var(--v-primary-base) !important

.height-convidados
    min-height 30px !important
    height 30px !important
</style>
